import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=cd3771e4&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=js"
export * from "./ArticlePreview.vue?vue&type=script&lang=js"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=cd3771e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3771e4",
  null
  
)

export default component.exports